import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricMissedImprBing extends MetricBase {
    constructor() {
        super({
            field: "metric_missed_impr",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.missedImpr.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.missedImpr.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.missedImpr.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricMissedImprBing;
